<template>
  <div class="news">
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-text">
          <h1>新闻动态</h1>
          <p>了解华视科技的最新动态和行业资讯</p>
        </div>
        <div class="hero-image">
          <img src="https://huashi-ai.oss-cn-wuhan-lr.aliyuncs.com/project-shuke/image/top.png" alt="新闻动态" class="ai-character" />
        </div>
      </div>
    </div>
    
    <div class="news-content">
      <div class="container">
        <!-- Featured News Section -->
        <div class="featured-news" v-if="newsList.length > 0">
          <div class="featured-news-content">
            <div class="featured-content">
              <h2>{{ newsList[0].title }}</h2>
              <p>{{ newsList[0].description }}</p>
          
            </div>
            <div>
              <button class="view-details-btn" @click="goToNewsDetail(newsList[0].id)">
                查看详情
                <span class="arrow">→</span>
              </button>
            </div>
          </div>
          <div class="featured-image">
            <img :src="newsList[0].img" alt="新闻图片" />
          </div>
        </div>

        <!-- News List Section -->
        <div class="news-list">
          <div v-for="item in newsList.slice(1)" :key="item.id" class="news-item" @click="goToNewsDetail(item.id)">
       
            <div class="news-item-image">
              <img :src="item.img" alt="新闻图片" />
            </div>
            <div class="news-right-content">
              <div class="news-item-content">
                <h3>{{ item.title }}</h3>
                <div :title="item.description">{{ item.description }}</div>
              </div>
              <div class="news-item-arrow"><img src="@/assets/icon/arrow.png" alt="arrow" /></div>
            </div>
            <div class="news-item-date">{{ item.date }}</div>
          </div>
        </div>

        <!-- Load More Button -->
        <!-- <div class="load-more-section">
          <button class="load-more-btn">加载更多</button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      newsList: [
        {
            id: 20251031,
            title: '华视闪宝屏形机器人亮相武汉建博会，AI数字人解决方案引关注',
            description: '10月31日，2025国际（武汉）智能建造产业博览会在中国光谷科技会展中心 隆重开幕。博览会由中建三局、华为、清华大学等24家单位共同主办，重点关注行业当前面临的痛点与发展趋势。',
            date: '2025-10-31',
            img: require('@/assets/image/news/10-31-2.jpg'),
        },
        {
          id: 20251024,
          title: '华视AI屏形机器人入驻武汉阿里中心，助力滨江数创走廊政务智能升级',
          description: '10月22日，武汉阿里中心正式开园。活动现场，华视集团自主研发的屏形机器人凭借领先的AI交互能力与智能化一站式服务，为滨江数创走廊政务服务站注入数字新活力，成为全场关注的亮点之一。阿里巴巴集团公共事务总裁闻佳、武昌区委书记余松、区长范礼奎等领导嘉宾现场与华视AI屏形机器人互动交流。',
          date: '2025-10-24',
          img: require('@/assets/image/news/1.jpg'),
        },
        {
          id: 20251023,
          title: '随县人民政府与华视集团签署数字经济产业项目合作协议',
          description: '10月23日，华视集团与随县人民政府成功举行数字经济产业项目签约仪式。随县县委书记陈良、华视集团董事长陈继承等双方领导出席活动并见证签约',
          date: '2025-10-23',
          img: require('@/assets/image/news/10-23-2.jpg')
        },
        {
          id: 20251017,
          title: '武汉市司法局局长、民建武汉市委会主委穆书芹考察调研华视集团',
          description: '10月17日，武汉市司法局局长、民建武汉市委会主委穆书芹率队莅临华视集团东湖总部，开展考察调研工作，实地了解企业在人工智能领域的发展现状，重点考察公司在AI技术方面的创新成果与应用场景。武汉市政协副秘书长、民建市委会专职副主委徐莉陪同考察。',
          date: '2025-10-17',
          img: require('@/assets/image/news/10-17.jpg')
        },
        {
          id: 20251011,
          title: '湖北公路客运集团到访华视集团考察交流，共商数字技术赋能智慧交通',
          description: '10月10日，湖北公路客运集团股份有限公司党委书记、董事长李青松率高管团队莅临华视集团，围绕AI数字人技术在智慧交通领域的创新应用开展实地考察与座谈交流。湖北公路客运集团副总经理钱浪、方松、库俊杰共同参与本次考察。',
          date: '2025-10-11',
          img: require('@/assets/image/news/10-11.jpg')
        },
        {
          id: 20250919,
          title: '2025中国文旅博览会：华视闪宝首秀引关注，赋能文旅产业创新升级',
          description: '9月12日至14日，2025中国文化旅游产业博览会在武汉国际博览中心成功举办。华视闪宝数字人系列产品以创新的前沿科技与丰富的应用场景成为展会焦点，全面展示数字人技术在文旅产业的最新成果，获得了业界广泛认可。',
          date: '2025-9-19',
          img: require('@/assets/image/news/9-19.jpg')
        },
        // {
        //   id: 20250918,
        //   title: '关注度拉满！华视闪宝亮相文旅博览会，获20余家央省市媒体集中报道',
        //   description: '近日，华视闪宝数字人精彩亮相2025中国文化旅游产业博览会，迅速成为全场焦点，吸引行业广泛关注。包括人民网、光明日报、新华网、央广网、中新网、湖北日报、长江日报等在内的20余家央级、省级及市级媒体相继进行报道，使其成为本届文博会“科技赋能文旅”的代表案例。',
        //   date: '2025-9-18',
        //   img: require('@/assets/image/news/9-18.png')
        // },
        {
          id: 20250917,
          title: '华视闪宝与四十余家单位达成战略合作，共拓智慧文旅新格局',
          description: '在2025中国文化旅游产业博览会上，华视集团与四十余家单位正式达成华视闪宝战略合作，各方将共同推进AI数字人项目的落地应用。此次大规模合作标志着华视闪宝在文旅数字化解决方案方面获得了行业广泛认可，进一步巩固了市场领先地位。',
          date: '2025-9-17',
          img: require('@/assets/image/news/9-17.jpg')
        }
      ]
    }
  },
  mounted() {
    this.scrollToTop();
  },
  methods: { 
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToNewsDetail(id) {
      this.$router.push({
        name: 'NewsDetail',
        params: { id }
      })
    }
  }
}
</script>

<style scoped>
.news {
  min-height: 100vh;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(#93BEEB 0%, #F0F7FD 100%);
  position: relative;
  overflow: hidden;
}

.hero-content {
  margin-left: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
  min-height: 400px;
}

.hero-text {
  flex: 1;
  max-width: 40%;
  position: relative;
  z-index: 10;
}

.hero-text h1 {
  color: #2c3e50;
  margin-bottom: 20px;
  width: 256px;
  height: 84px;

  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 700;
  font-size: 64px;
  line-height: 84px;
  color: #222222;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.hero-text p {
  font-size: 1.2rem;
  color: #2c3e50;
  line-height: 1.6;
  max-width: 500px;
  font-family: 'Microsoft YaHei';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  color: #333333;
  white-space: nowrap;
  overflow: visible;
  margin-bottom: 10px;
  position: relative;
  z-index: 11;

  flex: none;
  order: 1;
  flex-grow: 0;
}

.hero-image {
  position: relative;
  height: 400px;
  flex-shrink: 0;
  z-index: 1;
}

.ai-character {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transform: scaleX(-1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.news-content {
  padding: 40px 0;
}

/* Featured News Section */
.featured-news {
  display: flex;
  gap: 30px;
  margin-bottom: 40px;
  padding: 30px;
  background: white;
  border-radius: 10px;
}

.featured-news-content {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.featured-content {
  flex: 1;
}

.featured-content h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 20px;
  line-height: 1.4;
}

.featured-content p {
font-family: 'Microsoft YaHei';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 28px;
/* or 175% */

color: #333333;


/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;


}

.view-details-btn {
  background: linear-gradient(to right, #2F7FB9, #045FB2);

  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.view-details-btn:hover {
  background: #2980b9;
}

.arrow {
  font-size: 1.2rem;
}

.featured-image {
  height: 350px;
  flex: 1;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* News List Section */
.news-list {
  margin-bottom: 40px;
}

.news-item {
  display: flex;
  padding: 20px;
  background: white;
  margin-bottom: 15px;
  transition: transform 0.2s ease;
  cursor: pointer;
}

.news-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 1px 10px 2px rgba(0,0,0,0.1)
}


.news-item-image {
  width: 240px;
  height: 140px;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
  overflow: hidden;
}

.news-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-item-content {
  flex: 1;
  margin-right: 20px;
}

.news-item-content h3 {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 5px;
  font-weight: 600;
}

.news-item-content div {
  color: #666666;
  font-size: 0.9rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}

.news-right-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.news-item-arrow {
  color: #bdc3c7;
  font-size: 1.2rem;
  margin-right: 20px;
}

.news-item-arrow img {
  width: 16px;
  height: 16px;
  display: block;
}

.news-item-date {
  color: #666666;
  font-size: 0.9rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

/* Load More Section */
.load-more-section {
  text-align: center;
  margin-top: 40px;
}

.load-more-btn {
  border: none;
  padding: 12px 30px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 10px 62px;
  gap: 10px;
  background-color: #fff;
  border: 1px solid #D9D9D9;
  color: #333333;
}

.load-more-btn:hover {
  background: #d5dbdb;
}

@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    text-align: center;
    margin-left: 5%;
    padding: 20px 0;
  }
  
  .hero-text {
    max-width: 100%;
    margin-bottom: 20px;
  }
  
  .hero-text h1 {
    font-size: 2.5rem;
    width: auto;
  }
  
  .hero-text p {
    white-space: normal;
    max-width: 100%;
  }
  
  .hero-image {
    width: 250px;
    height: 300px;
    margin-top: 30px;
    margin-left: 0;
  }

  .featured-news {
    flex-direction: column;
  }
  
  .featured-image {
    width: 100%;
    height: 200px;
  }
  
  .news-item {
    flex-direction: column;
    text-align: center;
  }
  
  .news-item-image {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .news-item-content {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .news-item-arrow {
    margin-right: 0;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 2rem;
  }
  
  .hero-text p {
    font-size: 1rem;
    white-space: normal;
  }
  
  .hero-image {
    width: 200px;
    height: 250px;
  }
}
</style>
